import React from 'react';
import { Table } from 'semantic-ui-react';
import SimpleCell from '@/components/table/SimpleCell';
import MessageCell from '@/components/table/MessageCell';

const ClauseProfileRow = ({
  count,
  first,
  label,
  total,
}) => (
  <Table.Row className="aridhia-clause-profile-row">
    {first && (<MessageCell colSpan={3} className="dib bold" messageId="cohort.counts.entities.title" />)}
    {!first && (<Table.Cell colSpan={3} />)}
    <SimpleCell content={label} />
    <SimpleCell content={count} />
    <SimpleCell content={total} />
  </Table.Row>
);

export default ClauseProfileRow;
